import { render, staticRenderFns } from "./ComponentContextMenu.vue?vue&type=template&id=1d61f802&scoped=true&"
import script from "./ComponentContextMenu.vue?vue&type=script&lang=js&"
export * from "./ComponentContextMenu.vue?vue&type=script&lang=js&"
import style0 from "./ComponentContextMenu.vue?vue&type=style&index=0&id=1d61f802&lang=scss&scoped=true&"
import style1 from "./ComponentContextMenu.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d61f802",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VCardText,VIcon,VRow,VSpacer,VTextField,VTooltip})
